<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="showNewTicketDialog" id="new-ticket-dialog">
      <md-dialog-title>Create a new Ticket</md-dialog-title>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(createTicket)">
          <div class="md-layout">
            <div class="md-layout-item md-size-66">
              <md-field class="md-form-group" slot="inputs">
                <md-icon
                  ><i class="fas fa-tag text-primary hi-price-icon"></i
                ></md-icon>
                <label>Ticket Title</label>
                <md-input v-model="ticket.title" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field class="md-form-group" slot="inputs">
                <md-icon
                  ><i class="fas fa-ticket-alt text-primary hi-price-icon"></i
                ></md-icon>
                <label>Allocation</label>
                <md-input type="number" v-model="ticket.allocation"></md-input>
              </md-field>
            </div>

            <div class="md-layout-item md-size-33">
              <md-field class="md-form-group" slot="inputs">
                <md-icon
                  ><i class="fas fa-pound-sign text-primary hi-price-icon"></i
                ></md-icon>
                <label>GBP</label>
                <md-input v-model="ticket.prices.gbp" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field class="md-form-group" slot="inputs">
                <md-icon
                  ><i class="fas fa-euro-sign text-primary hi-price-icon"></i
                ></md-icon>
                <label>EUR</label>
                <md-input v-model="ticket.prices.eur" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-size-33">
              <md-field class="md-form-group" slot="inputs">
                <md-icon
                  ><i class="fas fa-dollar-sign text-primary hi-price-icon"></i
                ></md-icon>
                <label>USD</label>
                <md-input v-model="ticket.prices.usd" type="text"></md-input>
              </md-field>
            </div>
          </div>

          <md-dialog-actions>
            <md-button class="md-primary" @click="cancel">Cancel</md-button>
            <md-button type="submit" class="md-primary">Create</md-button>
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: "TicketCreateDialog",
  props: ["showNewTicketDialog", "departure", "ticket"],
  components: {},

  data() {
    return {};
  },

  methods: {
    createTicket() {
      this.$emit("created", this.ticket);
    },
    cancel() {
      this.$emit("cancelled");
    }
  }
};
</script>
<style lang="scss" scoped>
#new-ticket-dialog::v-deep .md-dialog-container {
  max-width: 768px;
  min-width: 768px;
  width: 768px;
}

form {
  padding-top: 10px;
}
</style>
